export default function PlayTimeIco() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 5C0 2.64297 -5.96046e-08 1.46446 0.732235 0.732235C1.46446 -5.96046e-08 2.64297 0 5 0C7.357 0 8.53555 -5.96046e-08 9.26775 0.732235C10 1.46446 10 2.64297 10 5C10 7.357 10 8.53555 9.26775 9.26775C8.53555 10 7.357 10 5 10C2.64297 10 1.46446 10 0.732235 9.26775C-5.96046e-08 8.53555 0 7.357 0 5Z"
        fill="#FF5C77"
      />
    </svg>
  );
}
